<template>
  <v-progress-circular indeterminate :size="size" :width="width" />
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    size?: number;
    width?: number;
  }>(),
  {
    size: 20,
    width: 3,
  },
);
</script>
